import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, RulerIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage plan-grid relative isolate overflow-hidden" data-id="element-103" data-mp="sai3509k0p57">
      <div className="rule-gold h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="ncgk2fc4optq" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neawt6d8xbmq">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-forest/25 bg-white px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-forest shadow-card" data-id="element-106" data-mp="3d2tod9lewkej">
          <RulerIcon className="h-4 w-4 text-earth" aria-hidden="true" data-id="element-107" data-mp="39b4gcyqfxq1v" /> Surveying &amp; Topography Teacher Ready
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-forestDeep sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e7uzxw1gf3s1">
          Master your year of surveying &amp; topography
          <br data-id="element-109" data-mp="2vjpzaxg3fyxg" />
          <span className="text-earth" data-id="element-110" data-mp="2vj7uhcfd8cdx">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hkgh5s8buuqu">
          <img src={productImage} alt="Surveying & Topography Teacher Ready: nine volumes and four exclusive bonuses covering fundamentals, measurements, leveling, traversing, instruments, GNSS, topographic surveys, applied surveying and teaching" className="mx-auto w-full rounded-xl drop-shadow-[0_18px_34px_rgba(30,48,28,.22)]" data-id="element-112" data-mp="nbbe31x26h6v" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="161szsmjh4ciq">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="162uf537ivl69">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-forestDeep" data-id="element-115" data-mp="114kkctppmml6">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-line bg-white px-3 py-2" data-id="element-116" data-mp="3ltqeji9dp5w5">
              <Icon className="h-3.5 w-3.5 text-forest" aria-hidden="true" data-id="element-117" data-mp="1x9krqeihcqdi" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-inkSoft" data-id="element-118" data-mp="21bfuzojz1dtx">
          Created by surveying specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}